import * as React from 'react';
import {
  AppLocalizationKey,
  ExamplesItem as TExamplesItem,
} from '~/common/types/types';
import { FormattedMessage, Image } from '~/components/common/common';
import { TechList } from '../tech-list/tech-list';
import * as styles from './examples-item.module.scss';

type Props = {
  item: TExamplesItem;
  techListTitle: AppLocalizationKey;
};

const ExamplesItem: React.FC<Props> = ({ item, techListTitle }) => (
  <article className={styles.item}>
    <div className={styles.content}>
      <h3 className={styles.title}>
        <FormattedMessage message={item.title} />
      </h3>
      <p className={styles.description}>
        <FormattedMessage message={item.description} />
      </p>
      <h5 className={styles.techListTitle}>
        <FormattedMessage message={techListTitle} />
      </h5>
      <TechList items={item.technologies} />
    </div>
    <div className={styles.imgView}>
      <div
        className={styles.imgBackgroundColor}
        style={{ backgroundColor: item.imgBackgroundColor ?? 'transparent' }}
      />
      <div className={styles.imgWrapper}>
        <Image
          className={styles.img}
          src={item.imgPath}
          loading="eager"
          alt={item.title}
          isDraggable={false}
        />
      </div>
    </div>
  </article>
);

export { ExamplesItem };
